import React, { useState, useEffect } from "react";
import styled from "styled-components";
import EditIcon from "../../../../assets/img/icons/Edit.svg";
import KeywordSource from "./KeywordSource";
import FooterActionButton from "./FooterActionButton";
import Input from "../../../Common/Components/Input";
import SearchTerm from "../../../Content/Search/Components/SearchTerm";
import TickNormal from "../../../../assets/img/icons/tickNormal.svg";
import crossNormal from "../../../../assets/img/icons/crossNormal.svg";
import ArrowBox from "../../../OnBoarding/Components/ArrowBox";
import ArrowBoxPopover from "modules/OnBoarding/Components/ArrowBoxPopover";
import { setCampaignAndEmailsStep, setCreateCampaignStep } from "modules/OnBoarding/actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import KeywordSourceV2 from "./KeywordSourceV2";
import { dynamicAudienceSearch, searchLists, searchPeople } from "../actions";

type Props = {
  aToggle?: boolean;
  onCancel?: any;
  handleCreateNewCampaign?: any;
  handleOnClickBrowsePeople?: any;
  campaignKeywords?: Array<string>;
  setCampaignKeywords?: any;
  handleOnRemoveCampaignKeyword?: any;
  campaignName?: string;
  setCampaignName?: any;
  toggleCampaignSaveDisable?: any;
  setToggleCampaignSaveDisable?: any;
  assetFlow?: boolean;
  handleOnClickTestKeywords?: any;
  selectedContactNames?: string[];
  selectedContactIds?: any[];
  handleAddPeople?: any;
  selectedListIds?: any[];
  selectedListNames?: string[];
  showAudienceAsider?: boolean;
  inDetailProfile?: boolean;
};

const CampaignAsider: React.FC<Props> = ({
  aToggle,
  onCancel,
  handleCreateNewCampaign,
  handleOnClickBrowsePeople,
  campaignKeywords,
  setCampaignKeywords,
  handleOnRemoveCampaignKeyword,
  handleOnClickTestKeywords,
  campaignName,
  setCampaignName,
  toggleCampaignSaveDisable,
  setToggleCampaignSaveDisable,
  assetFlow = false,
  selectedContactIds,
  selectedContactNames,
  handleAddPeople,
  selectedListIds,
  selectedListNames,
  showAudienceAsider,
  inDetailProfile,
}) => {
  const [toggleAssetNameEdit, setToggleAssetNameEdit] = useState("editable-active");
  const [audienceShown, setAudienceShown] = useState(false); // for checking if the audience sider open or closed
  const campaignsAndEmails = useSelector((state: RootState) => state.user.campaignAndEmails);
  const campaignsAndEmailsStep = useSelector((state: RootState) => state.user.campaignAndEmailsStep);
  const recommendedPeopleSearchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  // const showCreateCampaignOnBoarding = campaignsAndEmails === 1;
  const showCreateCampaignOnBoarding = false; // disable onboarding for now

  function handleAddSearchTerm(newSearchTerm: string) {
    let newSearchTerms = newSearchTerm.split(",");
    newSearchTerms = newSearchTerms
      .map((word) => word.trim())
      .map((word) => word.toLowerCase().replace(" and ", " AND "))
      .filter((word) => word !== "");
    if (campaignKeywords) {
      let updatedSearchTerms = Array.from(new Set([...campaignKeywords, ...newSearchTerms]));
      setCampaignKeywords(updatedSearchTerms);
    } else {
      let updatedSearchTerms = Array.from(new Set([...newSearchTerms]));
      setCampaignKeywords(updatedSearchTerms);
    }
    let keywords: string[];
    if (campaignKeywords !== undefined) keywords = [...campaignKeywords, newSearchTerm];
    else keywords = [];
    if (!recommendedPeopleSearchTerm && keywords.length > 0) {
      dynamicAudienceSearch(0, 50, "", keywords.toString());
    } else if (recommendedPeopleSearchTerm && keywords.length > 0) {
      dynamicAudienceSearch(0, 50, recommendedPeopleSearchTerm, keywords.toString());
    } else if (recommendedPeopleSearchTerm && keywords.length === 0) {
      searchPeople(0, 50, keywords.toString(), false);
    }
    searchLists(keywords.toString(), true);
  }

  const handleNameInput = (e: any) => {
    if (toggleCampaignSaveDisable === "disabled" && e.target.value.trim() !== "") {
      setToggleCampaignSaveDisable("");
    } else if (e.target.value.trim() === "") {
      setToggleCampaignSaveDisable("disabled");
    }
    setCampaignName(e.target.value);
  };

  const onFocusName = () => {
    setCreateCampaignStep(0);
  };
  const onFocusKeywords = () => {
    setCreateCampaignStep(1);
  };
  const onFocusPeople = () => {
    setCreateCampaignStep(2);
  };
  const onFocusSave = () => {
    setCreateCampaignStep(0);
  };

  const onBlurName = () => {
    setCreateCampaignStep(1);
  };
  const onBlurKeywords = () => {
    setCreateCampaignStep(2);
  };
  const onBlurPeople = () => {
    setCreateCampaignStep(3);
  };
  const onBlurSave = () => {
    setCreateCampaignStep(0);
  };

  useEffect(() => {
    if (showCreateCampaignOnBoarding) {
      if (showAudienceAsider && !audienceShown) {
        setAudienceShown(true);
      } else if (!showAudienceAsider && audienceShown) {
        setAudienceShown(false);
        // onBlurPeople();
      } else {
        setAudienceShown(false);
      }
    }
  }, [showAudienceAsider]);

  const handleSave = () => {
    handleCreateNewCampaign();
  };

  const handleCancel = () => {
    // setCreateCampaignStep(0);
    document.body.style.overflow = !inDetailProfile ? "auto" : "hidden";
    onCancel();
  };

  const handleBrowse = () => {
    if (handleOnClickBrowsePeople) {
      handleOnClickBrowsePeople();
      // setCreateCampaignStep(4);
    }
  };

  return (
    <Wrapper
      className={`wrapper-campaign-keyword ${aToggle ? "open" : ""}`}
      style={{ borderLeft: assetFlow ? "2px solid #e4e4e4" : "0" }}
    >
      <div className="create-campaign-wrapper-two">
        <h1 className="create-campaign-heading">
          Create New
          <br />
          Campaign
        </h1>
        <div className={`edit-wrapper-two ${toggleAssetNameEdit}`}>
          {/* Toggle editable-active class */}
          <span className="name-two">
            <Input
              type="text"
              id="createCampaignName"
              label="Name your new campaign *"
              placeholder="Name your new campaign"
              value={campaignName}
              onChange={handleNameInput}
              onKeyPress={(e: any) => {
                if (e.key === "Enter") {
                  setToggleAssetNameEdit("");
                }
              }}
            // {...(showCreateCampaignOnBoarding
            //   ? {
            //     onFocus: onFocusName,
            //     onBlur: onBlurName,
            //   }
            //   : {})}
            />
          </span>
        </div>
        <div className="scroll-Wrapper-two">
          <div className="search-terms-wrap">
            <KeywordSourceV2
              // {...(showCreateCampaignOnBoarding
              //   ? {
              //       onFocus: onFocusKeywords,
              //       onBlur: onBlurKeywords,
              //     }
              //   : {})}
              // inputId="createCampaignAutoSourceInput"
              heading="Keywords to auto-source content and contacts:"
              subText="optional"
              desClassName={campaignKeywords && campaignKeywords?.length > 0 ? "mb-s" : ""}
              placeholder={campaignKeywords?.length === 0 ? "Type keyword to find matching content and contacts…" : ""}
              desc="Help our Smart Engine find the most valuable, relevant, and timely content and best matching contacts for your campaigns and emails automatically."
              searchTerms={campaignKeywords}
              includedKeywordsCount
              handleAddSearchTerm={handleAddSearchTerm}
              handleOnRemove={handleOnRemoveCampaignKeyword}
            />
          </div>

          <KeywordSource
            // {...(showCreateCampaignOnBoarding
            //   ? {
            //       onFocus: onFocusPeople,
            //       onBlur: onBlurPeople,
            //     }
            //   : {})}
            heading="Add contacts and lists"
            subText="optional"
            showInput={false}
            desClassName={selectedContactIds && selectedContactIds.length > 0 ? "mb-s" : ""}
            placeholder="Start typing Keywords to find matching content…"
            desc=""
          >
            <span className="test" id="createCampaignAddPeopleInput" onClick={handleBrowse}>
              Browse
            </span>
          </KeywordSource>
          {selectedContactNames && selectedContactIds && selectedContactNames.length > 0 ? (
            <div>
              {selectedContactNames.map((name: any, index: number) => {
                return (
                  <SearchTerm
                    key={index}
                    hideSearchIcon={true}
                    searchTerm={name}
                    onRemove={() => handleAddPeople(selectedContactIds[index], name, "contact")}
                  // isExtended={true}
                  />
                );
              })}
            </div>
          ) : null}
          {selectedListNames && selectedListIds && selectedListNames.length > 0 ? (
            <div>
              {selectedListNames.map((name: any, index: number) => {
                return (
                  <SearchTerm
                    key={index}
                    hideSearchIcon={true}
                    searchTerm={name}
                    onRemove={() => handleAddPeople(selectedListIds[index], name, "list")}
                    isExtended={true}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
      <FooterActionButton>
        <span className="footer-btn mr" onClick={handleCancel}>
          Cancel
        </span>
        <span
          className={`footer-btn filled-success ${toggleCampaignSaveDisable}`}
          onClick={handleSave}
          id="createCampaignSaveButton"
        >
          Save
        </span>
      </FooterActionButton>
    </Wrapper>
  );
};

export default CampaignAsider;

const Wrapper = styled.div`
  transition: ease all 0.1s;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  width: 0px;
  background-color: #fff;
  position: relative;
  &.open {
    min-width: 100%;
    transition: ease all 0.1s;
    overflow: hidden;
    padding: 42px 40px 30px 40px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 25px 20px 30px 20px;
    }
    @media all and (max-height: 1439px) and (min-height: 600px) {
      justify-content: space-between;
      align-items: center;
      .btn-wrapper {
        display: flex;
        align-items: center;
        .ml {
          margin-left: 12px;
        }
      }
    }
    .asset-name-two {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      // max-width: 700px;
      // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      //   max-width: 445px;
      // }
    }
    .name-two {
      color: rgb(155, 155, 155);
      position: relative;
      float: left;
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      div {
        width: 100%;
      }
      .tooltip {
        position: relative;
        display: inline-block;
        opacity: 1;
        z-index: 0;
        .tooltiptext {
          color: #ffffff;
          font-size: 11px;
          letter-spacing: 0.02px;
          line-height: 15px;
          text-align: center;
          background-color: #263153;
          visibility: hidden;
          border-radius: 4px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          padding: 5px 10px;
          &:after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #263153 transparent transparent transparent;
          }
        }
        &:hover .tooltiptext {
          visibility: visible;
          opacity: 1;
        }
      }
      .asset-name-two {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        float: left;
        // max-width: 700px;
        // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        //   max-width: 445px;
        // }
      }
      &.editable-active {
        .editable {
          display: block;
        }
      }
      .editable {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        display: none;
        label {
          display: none;
        }
        input {
          padding-right: 70px;
        }
        .save {
          position: absolute;
          top: 9px;
          right: 10px;
          height: 100%;
          cursor: pointer;
          img {
            vertical-align: middle;
            max-width: 20px;
          }
        }
        .cancel {
          position: absolute;
          top: 9px;
          right: 40px;
          height: 100%;
          cursor: pointer;
          img {
            vertical-align: middle;
            max-width: 20px;
            padding: 2px;
          }
        }
      }
      .edit-btn {
        cursor: pointer;
        margin-left: 10px;
      }
    }
    .scroll-Wrapper-two {
      height: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      max-height: calc(100vh - 380px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: calc(100vh - 290px);
      }
      padding-left: 5px;
      margin-left: -5px;
      .search-terms-wrap {
        .wrapper-content {
          flex-direction: row;
          align-items: baseline;
        }
      }

      scrollbar-width: thin;
      scrollbar-color: #001760 #efefef;
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
    .create-campaign-wrapper-two {
      position: relative;
      .create-campaign-heading {
        color: #424b50;
        font-size: 46px;
        font-weight: 500;
        line-height: 48px;
        margin-bottom: 0px;
        display: block;
        font-family: "Roboto Slab", serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 32px;
          line-height: 40px;
        }
      }
      .edit-wrapper-two {
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 10px;
          margin-bottom: 10px;
        }
        .new-campaign {
          color: #9b9b9b;
          font-size: 22px;
          line-height: 47px;
          margin-bottom: 0px;
          display: inline-block;
          font-family: "Roboto Slab", serif;
        }
        .edit-icon {
          margin-left: 10px;
          cursor: pointer;
        }
        &.editable-active {
          .editable {
            display: block;
          }
        }
      }
    }
  }
  .search-terms-wrap {
    .add-words-wrapper {
      margin: 20px 0 35px 0;
      label {
        margin: 0;
      }
    }
  }
`;
